import { render, staticRenderFns } from "./alreadyReceiveList.vue?vue&type=template&id=8ca04174&scoped=true"
import script from "./alreadyReceiveList.vue?vue&type=script&lang=js"
export * from "./alreadyReceiveList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca04174",
  null
  
)

export default component.exports